jQuery($ => {
    class SlideMenu {
      constructor(element) {
        this._          = element;
        this._element   = $(element);
        this._item      = this._element.find('.m-slide-menu__item');
        this._link      = this._element.find('.m-slide-menu__link');
        this._slideLink = this._element.find('.m-slide-menu__link--has-slide');
        this._backLink  = this._element.find('.m-slide-menu__link--back');
        this._slide     = this._element.find('.m-slide-menu__slide');

        this.focusable = 'button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';
  
        this.init();
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Initialize
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      init() {
        this.setupHandlers();
        this._element.trigger( 'slide-menu:init', this );
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Setup Handlers
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      setupHandlers() {
        this._slideLink.on('mousedown', this.handleSlideLinkMousedown);
        this._slideLink.on('keydown', this.handleSlideLinkKeydown);
        this._backLink.on('mousedown', this.handleBackLinkMousedown);
        this._backLink.on('keydown', this.handleBackLinkKeydown);
        this._element.find(this.focusable).on('keydown', this.handleFocusableKeydown);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Activate Link
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      activateLink = $link => {
        $link.addClass('m-slide-menu__link--active');
        $link.attr('aria-expanded', 'true');
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Deactivate Link
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      deactivateLink = $link => {
        $link.removeClass('m-slide-menu__link--active');
        $link.attr('aria-expanded', 'false');
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Open Slide
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      openSlide = $slide => {
        const slideId   = $slide.attr('id');
        const $backLink = $slide.find(`#${slideId}_back`);

        $slide.addClass('m-slide-menu__slide--open');
        
        setTimeout(() => {
          $backLink.focus();
        }, 200);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Close Slide
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      closeSlide = $slide => {
        const controlledby = $slide.data('controlledby');
        const $link        = $(`#${controlledby}`);

        $slide.removeClass('m-slide-menu__slide--open');
        
        setTimeout(() => {
          $link.focus();
        }, 200);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Slide Link Activate
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleSlideLinkActivate = $link => {
        const slideId = $link.attr('aria-controls');
        const $slide  = $(`#${slideId}`);

        this.activateLink($link);
        this.openSlide($slide);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Slide Link Deactivate
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleSlideLinkDeactivate = $link => {
        const slideId = $link.attr('aria-controls');
        const $slide  = $(`#${slideId}`);

        this.deactivateLink($link);
        this.closeSlide($slide);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Slide Link Mousedown
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleSlideLinkMousedown = event => {
        event.preventDefault();

        const $link = $(event.currentTarget);

        this.handleSlideLinkActivate($link);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Slide Link Keydown
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleSlideLinkKeydown = event => {
        const $link = $(event.currentTarget);

        switch (event.key) {
          case 'Enter':
          case 'ArrowRight':
            event.preventDefault();
  
            this.handleSlideLinkActivate($link);
            break;
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Focusable Keydown
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleFocusableKeydown = event => {
        const $focusable      = $(event.currentTarget);
        const $slide          = $focusable.closest('.m-slide-menu__slide, .m-slide-menu');
        const $subslide       = $slide.find('.m-slide-menu__slide');
        const $slideFocusable = $slide.find(this.focusable).not($subslide.find(this.focusable));
        const focusableIndex  = $slideFocusable.index($focusable);

        const $first = $slideFocusable.first();
        const $last  = $slideFocusable.last();

        switch (event.key) {
          case 'Tab':
            if (
              ($focusable.is($last) && !event.shiftKey) ||
              ($focusable.is($first) && event.shiftKey)
            ) {
              event.preventDefault();

              if ($focusable.is($last)) {
                $first.focus();
              } else {
                $last.focus();
              }
            }
            break;

          case 'Escape':
          case 'Esc':
            event.preventDefault();
  
            const controlledby = $slide.data('controlledby');
            const $link        = $(`#${controlledby}`);

            this.handleSlideLinkDeactivate($link);
            break;

          case "ArrowUp":
            event.preventDefault();
            const $prev = $slideFocusable.eq(focusableIndex - 1);

            if ($prev[0]) {
              $prev.focus();
            } else {
              $last.focus();
            }
            break;
  
          case "ArrowDown":
            event.preventDefault();
            const $next = $slideFocusable.eq(focusableIndex + 1);

            if ($next[0]) {
              $next.focus();
            } else {
              $first.focus();
            }
            break;
  
          case "Home":
            event.preventDefault();
            $first.focus();
            break;
  
          case "End":
            event.preventDefault();
            $last.focus();
            break;
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Back Link Mousedown
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleBackLinkMousedown = event => {
        event.preventDefault();

        const $link        = $(event.currentTarget);
        const $slide       = $link.closest('.m-slide-menu__slide');
        const controlledby = $slide.data('controlledby');
        const $slideLink   = $(`#${controlledby}`);

        this.deactivateLink($slideLink);
        this.closeSlide($slide);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Back Link Keydown
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleBackLinkKeydown = event => {
        const $link        = $(event.currentTarget);
        const $slide       = $link.closest('.m-slide-menu__slide');
        const controlledby = $slide.data('controlledby');
        const $slideLink   = $(`#${controlledby}`);

        switch (event.key) {
          case 'Enter':
          case 'ArrowLeft':
            event.preventDefault();
  
            this.deactivateLink($slideLink);
            this.closeSlide($slide);
            break;
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Reset
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleReset = () => {
        this._slideLink.filter('.m-slide-menu__link--active').each((_, link) => {
          this.deactivateLink($(link));
        });

        this._slide.filter('.m-slide-menu__slide--open').removeClass('m-slide-menu__slide--open');
      }
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $.fn.slide_menu = function() {
      var _ = this,
          opt = arguments[0],
          args = Array.prototype.slice.call(arguments, 1),
          l = _.length,
          i,
          ret;
      for (i = 0; i < l; i++) {
        if (typeof opt == 'object' || typeof opt == 'undefined')
          _[i].slide_menu = new SlideMenu(_[i], opt);
        else
          ret = _[i].slide_menu[opt].apply(_[i].slide_menu, args);
        if (typeof ret != 'undefined') return ret;
      }
      return _;
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $('.m-slide-menu').slide_menu();
});